import { render, staticRenderFns } from "./PieCategoryChart.vue?vue&type=template&id=e02d3c34&scoped=true&"
import script from "./PieCategoryChart.vue?vue&type=script&lang=js&"
export * from "./PieCategoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02d3c34",
  null
  
)

export default component.exports